import React from "react";
import "../../styles/MobileAppDownload.css";

const MobileAppDownload = () => {
  return (
    <div className="app-download-section">
      <div className="app-download-container">
        <div className="app-download-content">
          <div className="app-phones">
            <div className="phone-mockup phone-1">
              <div className="phone-screen">
                <div className="app-mockup">
                  <div className="mockup-header">
                    <div className="status-bar"></div>
                    <h3>Payment Method</h3>
                  </div>
                  <div className="payment-content">
                    <div className="payment-section">
                      <h4>Recommended payment methods</h4>
                      <div className="payment-option">
                        <div className="payment-icon card"></div>
                        <div className="payment-text">
                          <div>Credit/Debit Card</div>
                          <div className="payment-cards">
                            <div className="card-logo visa"></div>
                            <div className="card-logo master"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="payment-section">
                      <h4>Other Payment Methods</h4>
                      <div className="payment-option">
                        <div className="payment-icon cash"></div>
                        <div className="payment-text">Cash on Delivery</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="phone-mockup phone-2">
              <div className="phone-screen">
                <div className="app-mockup">
                  <div className="mockup-header">
                    <div className="status-bar"></div>
                    <h3>Hi there! 👋</h3>
                    <p>Please sign in to enjoy a better shopping experience</p>
                    <button className="signin-btn">Sign in</button>
                  </div>
                  <div className="mockup-content">
                    <div className="search-bar"></div>
                    <div className="promo-cards">
                      <div className="promo-card main"></div>
                      <div className="promo-card small"></div>
                    </div>
                    <div className="categories-grid">
                      {[1,2,3,4,5,6,7,8].map((i) => (
                        <div key={i} className="category-item"></div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Text Section */}
          <div className="app-download-text">
            <h2 className="app-title">Download Our Mobile App</h2>
            <p className="app-description">
              Everything you need, just a click away! Download our app now and
              enjoy the convenience of having the best products at your fingertips.
            </p>

            <div className="download-buttons">

              {/* GOOGLE PLAY BUTTON */}
              <a
                href="https://play.google.com/store/apps/details?id=com.ableinnovation.easy_world_customer&hl=en"
                className="download-btn google-play"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="btn-content">
                  
                  {/* Correct Google Play Icon */}
                  <svg width="24" height="24" viewBox="0 0 512 512">
                    <path fill="#34A853" d="M325.3 234.3L104.6 13.6C96.7 5.7 84 5.7 76.1 13.6L256 256l69.3-21.7z"/>
                    <path fill="#4285F4" d="M325.3 277.7L256 256 76.1 498.4c7.9 7.9 20.6 7.9 28.5 0l220.7-220.7z"/>
                    <path fill="#FBBC04" d="M373.3 210.3l-48-30.1L256 256l69.3 75.8 48-30.1c17.1-10.7 17.1-35.7 0-46.4z"/>
                    <path fill="#EA4335" d="M373.3 210.3L104.6 13.6c-7.9-7.9-20.6-7.9-28.5 0L325.3 234.3l48-24z"/>
                  </svg>

                  <div>
                    <div className="btn-subtitle">GET IT ON</div>
                    <div className="btn-title">Google Play</div>
                  </div>
                </div>
              </a>

              {/* APP STORE BUTTON */}
              <a
                href="https://apps.apple.com/us/app/easy-world-online-shopping-app/id6756601701"
                className="download-btn app-store"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="btn-content">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
                      fill="currentColor"
                    />
                  </svg>

                  <div>
                    <div className="btn-subtitle">Download on the</div>
                    <div className="btn-title">App Store</div>
                  </div>
                </div>
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppDownload;